<app-landingpage-header-child></app-landingpage-header-child>
<!-- <section>
    <div class="s-header">
        <nav class="navbar navbar-expand-lg navbar-dark bg-primary">
            <div class="container">
                <a class="navbar-brand brand-name" routerLink="{{linkHome}}">{{'header.home' | translate}}</a>
                <button class="navbar-toggler" type="button" data-toggle="collapse"
                    data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false"
                    aria-label="Toggle navigation">
                    <span class="navbar-toggler-icon"></span>
                </button>
                <div class="collapse navbar-collapse" id="navbarSupportedContent">
                    <ul class="navbar-nav mr-auto">
                    </ul>
                    <div class="pull-right mr-3">
                        <a (click)="onChangeLanguage('vi')"><img alt="vitenamese" src="./assets/images/vietnam.png" height="40px"></a>
                        <span class="text-white p-2">|</span>
                        <a (click)="onChangeLanguage('en')"><img alt="english" src="./assets/images/united-kingdom.png"
                                height="40px"></a>
                    </div>
                    <form class="form-inline my-2 my-lg-0 pull-right">
                        <button class="btn btn-outline-light my-2 my-sm-0" type="submit" (click)="login()">
                            {{'button.login' | translate}} </button>
                    </form>
                </div>
            </div>
        </nav>
    </div>
</section> -->
<section class="home-page pt-4 pb-4" *ngIf="!isApprovedError">
  <div class="container p-4">
    <div class="row">
      <!-- <div *ngIf="!messages" class="col-8 offset-2 text-center">
                <h4>{{'alert.page_not_found' | translate}}</h4>
                <h4>
                    {{'alert.back_home' | translate}}
                    <a class="navbar-brand brand-name" routerLink="{{linkHome}}">
                        <h4>{{'button.back_home' | translate}}</h4>
                    </a>
                </h4>
                <button mat-stroked-button color="primary" type="button" routerLink="{{linkHome}}">
                    <mat-icon class="mr-0">arrow_back</mat-icon>
                    {{ 'update_enterprise.buttons.btn_back_home' | translate }}
                </button>
            </div> -->
      <div class="col-lg-9 offset-2 text-center">
        <h3 style="font-size: 21px">{{ "header.notify" | translate }}</h3>
        <h5 class="mb-4" style="font-size: 14px">
          {{ "messages.api_rate_limit_request" | translate }}
        </h5>
        <button
          mat-stroked-button
          color="primary"
          type="button"
          routerLink="{{ linkHome }}"
        >
          <mat-icon class="mr-0">arrow_back</mat-icon>
          {{ "update_enterprise.buttons.btn_back_home" | translate }}
        </button>
      </div>
    </div>
  </div>
</section>

<section class="home-page pt-4 pb-4" *ngIf="isApprovedError">
  <div class="container p-4">
    <div class="row">
      <div class="col-lg-9 offset-2 text-center">
        <h3 style="font-size: 21px">{{ "header.notify" | translate }}</h3>
        <h5 class="mb-4" style="font-size: 14px">
          {{ messageApprovedError }}
        </h5>
        <button
          mat-stroked-button
          color="primary"
          type="button"
          routerLink="{{ linkHome }}"
        >
          <mat-icon class="mr-0">arrow_back</mat-icon>
          {{ "button.exit" | translate }}
        </button>
      </div>
    </div>
  </div>
</section>
<app-landingpage-footer></app-landingpage-footer>
